module.exports = __webpack_public_path__ + "img/40800.53c1d849.jpg";